import { Card, CardActionArea, CardContent, CardHeader, Grid2, Stack } from '@mui/material';
import { EventChip, EventChipType } from 'components/event/EventChip';
import { EventActionMenu } from 'components/event/actionMenu/EventActionMenu';
import { EventOccasion } from 'models/EventOccasion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { isElectron } from 'utils/isElectron';

export interface EventGridItemProps {
  event: EventOccasion;
  onDeleteEvent?: (event: EventOccasion) => void;
  onRestoreEvent?: (event: EventOccasion) => void;
  onDragStart?: (event: React.DragEvent) => void;
}

export function EventGridItem(props: EventGridItemProps) {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [mightRedirectTo, setMightRedirectTo] = useState<string | null>();
  const { event } = props;
  const navigate = useNavigate();
  // const { getLocalPlaylist } = useLocalPlaylist();
  // const { createPlaylistByType } = usePlaylistExport(props.event);

  useEffect(() => {
    if (!openDialog && mightRedirectTo) {
      navigate(mightRedirectTo);
    } else if (openDialog) {
      setMightRedirectTo(null);
    }
  }, [mightRedirectTo, openDialog]);

  // TODO: Need rework
  const handleDragStart = async (e: React.DragEvent) => {
    // e.preventDefault();
    // if (event.requests) {
    //   const localPlaylist = await getLocalPlaylist(event.requests);
    //   const playlistM3u = createPlaylistFileByType(PlaylistExportType.M3U, localPlaylist);
    //   // const playlistM3u = playlist ? createPlaylistM3u(playlist) : '';
    //   // TODO: Dragging is only available when requests are set
    //   // This needs a fallback info
    //   window.electron?.startDrag(`${event.name}.m3u`, playlistM3u);
    // }
  };

  return (
    <Grid2
      draggable={isElectron()}
      onDragStart={(e) => isElectron() && handleDragStart(e)}
      id={event.id}
      size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}
    >
      <Card elevation={1} sx={{ borderRadius: 3 }}>
        <CardActionArea
          disableRipple
          onClick={(ev) => {
            ev.preventDefault();

            if (!openDialog) {
              setMightRedirectTo(`/events/${event.id}`);
            }
          }}
        >
          <CardHeader
            action={
              <EventActionMenu
                event={event}
                onDeleteEvent={props.onDeleteEvent}
                onRestoreEvent={(event) => props.onRestoreEvent?.(event)}
                onCloseDialog={() => {
                  setOpenDialog(false);
                  setMightRedirectTo(null);
                }}
                onOpenDialog={() => {
                  setOpenDialog(true);
                }}
              />
            }
            title={event.name}
            sx={{ pb: 0 }}
          />
          <CardContent>
            <Stack direction="row" spacing={1} marginBottom={1} useFlexGap flexWrap="wrap">
              <EventChip type={EventChipType.Date} event={event} />
              <EventChip type={EventChipType.ExpireDate} event={event} />
              {event?.isLiveEvent && <EventChip type={EventChipType.Live} event={event} />}
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid2>
  );
}
